.ux-iws-async-modal {
    display: inline-block;

    &__iframe {
        height: 1px !important;
        left: -5000px !important;
        min-height: 1px !important;
        position: absolute !important;
        visibility: hidden !important;
        width: 1px !important;
    }
}
